<div class="panel-action">
    <div class="btn btn-secondary"
         ycnDisabled [disabled]="pageNum === 1 || disableButtons || isInitialState"
         (click)="pageChanged(PAGE_CONTROLS.FIRST)">First</div>
</div>
<div class="divider-vertical"></div>
<div class="panel-action">
    <div class="btn btn-secondary"
         ycnDisabled [disabled]="pageNum === 1 || disableButtons || isInitialState"
         (click)="pageChanged(PAGE_CONTROLS.PREV)">Prev</div>
</div>
<div class="divider-vertical"></div>
<div class="panel-action">
    <div class="btn btn-secondary"
         ycnDisabled [disabled]="pageNum >= paginationInfo.num_pages || disableButtons || isInitialState"
         (click)="pageChanged(PAGE_CONTROLS.NEXT)">Next</div>
</div>
<div class="divider-vertical"></div>
<div class="panel-action">
    <div class="btn btn-secondary"
         ycnDisabled [disabled]="pageNum >= paginationInfo.num_pages || disableButtons || isInitialState"
         (click)="pageChanged(PAGE_CONTROLS.LAST)">Last</div>
</div>
